// extracted by mini-css-extract-plugin
export var active = "LeftNavbar-module--active--wbi35";
export var container = "LeftNavbar-module--container--K+Ju7";
export var svgElem1 = "LeftNavbar-module--svg-elem-1--1hx2e";